import view from '../../view';
import { connectedStore } from '../../store';
import applyInsertion from '../../content-editable/helpers/apply-insertion';
import createMediaContainer from '../helpers/create-media-container';
import { IMAGE_SELECTOR } from '../../hdrm/constants/image-selector';
import addBaseHref from '../../assets/helpers/add-base-href';

const insertImage = async ({ source, width, height }) => {
  const store = connectedStore.get();
  const state = store.getState();
  const elementId = view.selectors.getFocusedElement(state);
  const element = view.accessors.getLiveElement(elementId);

  const containerAttrs = {
    contentPosition: '50% 50%',
    contentScale: '1',
    aspectRatio: width / height,
  };

  const imgAttrs = {
    src: addBaseHref(source),
  };

  const mediaContainerElement = createMediaContainer(containerAttrs, imgAttrs);
  await applyInsertion(element, mediaContainerElement.outerHTML);

  const image = element.querySelector(`img[src="${source}"]`);
  const imageElement = image && image.closest(IMAGE_SELECTOR);

  return {
    elementId,
    element,
    imageElement,
  };
};

export default insertImage;
